/* Imperative pan/zoom control for the one open map. A single live MapWidget registers its handler; any
   source (Live voice transcript, a chat/voice tool action) asks the map to move through mapControl().
   Returns false when no map is open so the caller can give honest feedback instead of silently doing nothing. */
let handler = null;

export const registerMapControl = (fn) => {
  handler = fn;
  return () => { if (handler === fn) handler = null; };
};

export const mapControlActive = () => !!handler;

export const mapControl = (cmd) => {
  if (handler && cmd) { handler(cmd); return true; }
  return false;
};

/* Parse a natural-language map command (TR + EN) into a bounded pan/zoom instruction, or null.
   Pan requires a direction AND a movement verb so ordinary speech ("sağ ol", "right then") never moves
   the map. Zoom verbs stand alone. "biraz/az/a bit" → small step, "çok/a lot" → large step. */
const ZOOM_OUT = /(uzaklaş|uzaklaştır|küçült|geri\s*çek|zoom\s*out|unzoom|zum\s*out)/i;
const ZOOM_IN = /(yakınlaş|yaklaş|yakınlaştır|büyüt|zoom\s*in|zoom\s*yap|yakınla|zum\s*yap|\bzoom\b|\bzum\b)/i;
const MOVE = /(git|gidelim|gid|kaydır|kaydıral|götür|taşı|oynat|ilerle|çevir|dön|move|pan|scroll|shift|go\b)/i;
const SMALL = /(biraz|azıcık|az\b|hafif|a\s*bit|a\s*little|slightly|little)/i;
const BIG = /(çok|iyice|bir\s*hayli|epey|a\s*lot|far|lots)/i;
const DIRS = [
  { re: /(sağ(a| a|\b)|right)/i, dx: 1, dy: 0 },
  { re: /(sol(a|\b)|left)/i, dx: -1, dy: 0 },
  { re: /(yukarı|yukarıya|up\b|kuzey|north)/i, dx: 0, dy: -1 },
  { re: /(aşağı|aşağıya|down\b|güney|south)/i, dx: 0, dy: 1 },
];

export function parseMapCommand(text) {
  const t = (text || "").toLowerCase();
  if (!t.trim()) return null;
  const small = SMALL.test(t), big = BIG.test(t);
  if (ZOOM_OUT.test(t)) return { op: "zoom", delta: small ? -1 : big ? -3 : -2, ack: "Haritayı uzaklaştırdım." };
  if (ZOOM_IN.test(t)) return { op: "zoom", delta: small ? 1 : big ? 3 : 2, ack: "Haritayı yakınlaştırdım." };
  const d = DIRS.find((x) => x.re.test(t));
  if (d && MOVE.test(t)) {
    const frac = small ? 0.25 : big ? 0.8 : 0.5;
    return { op: "pan", dx: d.dx, dy: d.dy, frac, ack: "Haritayı kaydırdım." };
  }
  return null;
}
